import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { BHost } from "../constants";

var OpenConfiguration = /*#__PURE__*/function () {
  function OpenConfiguration() {
    _classCallCheck(this, OpenConfiguration);

    _defineProperty(this, "options", {
      ignoreDomainDetect: false,
      // 默认需要做中转页检查
      ignoreHosts: [BHost]
    });
  }

  _createClass(OpenConfiguration, [{
    key: "register",
    value: function register(options) {
      if (!options) {
        return;
      }

      this.options.ignoreDomainDetect = !!options.ignoreDomainDetect;
      this.options = _objectSpread(_objectSpread({}, this.options), options);
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      return this.options;
    }
  }]);

  return OpenConfiguration;
}();

var defaultConfiguration = new OpenConfiguration();
export default defaultConfiguration;